import React, { useEffect } from 'react'
import styled from 'styled-components'
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {

  useEffect(()=>{
    AOS.init();
  },[])
  return (
    <>

    <Wrapper>
    <div className="container">
       <div className="about_data">
        <div className="image" data-aos="zoom-in"  data-aos-duration="800">
            <img src="./Images/aboutImage.png" alt="aboutImage" width={300}/>
        </div>
        <div className="data"  data-aos="zoom-in" data-aos-duration="800">
            <h1>About Me</h1>
            <p>Hello, I'm MD. Arslan, I've been working in front-end development and UI/UX design for 2+ years. What I love most about this work is making websites that look good and are easy for people to use. <br />
              During my career, I've had the chance to work on lots of different projects, each with its own interesting challenges. Whether it's starting from scratch to create a new website or making an existing app's design better, my main goal has always been the same: to make websites that not only look nice but are also super easy for people to understand and enjoy using. <br />
              I believe in your company's mission and vision, and I'm excited about how I can be a part of the team and help to reach its goals.</p>
              <div className="resume">
                    <a href="./Images/Arslan_Resume.pdf" download>Download Resume</a>
                </div>
        </div>
       </div>
    </div>
    <div className="line"></div>
    </Wrapper>
     
    </>
  )
}

export default About

const Wrapper =styled.section`
.container{
    width: 100%;
    height: auto;
    background-color: rgba(45, 46, 46, 1);
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 8%;
    padding-bottom: 8%;
}
.about_data{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.data{
  padding-left: 6%;
}
.data h1{
  padding-bottom: 15px;
  font-size: 35px;
  color: rgba(255, 204, 0, 1);
}
.resume{
  margin-top: 40px;
}
.resume a{
  color: rgba(255, 204, 0, 1);
  text-decoration: none;
  border: 2px solid rgba(255, 204, 0, 1);
  padding: 10px 20px;
  border-radius: 65px;
  transition: 0.8s;
}
.resume a:hover{
  background-color: rgba(255, 204, 0, 1);
  color: white;
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}

@media (max-width: 768px) {
  .about_data{
    display: flex;
    flex-direction: column;
  }
  .image img{
   width: 100%;
  }
  .data{
    padding-left: 0;
  }
  .data h1{
    font-size: 25px;
    margin-top: 20px;
  }
  .data p{
    font-size: 16px;
  }
  .resume a{
    font-size: 14px;
  }
}
`


